// covered-by: frontends/carrie/src/routes/ask-puntt/utils/__tests__/matchProjectFileForReview.test.ts

export type ProjectFileTagSource = {
  fileId: string;
  name?: string | null;
  tags?: string[] | null;
};

export type MatchedProjectFileTags = {
  fileId: string;
  tags: string[];
};

function basename(raw: string): string {
  const trimmed = raw.trim().toLowerCase();
  const slash = Math.max(trimmed.lastIndexOf("/"), trimmed.lastIndexOf("\\"));
  return slash >= 0 ? trimmed.slice(slash + 1) : trimmed;
}

/**
 * Resolve which project file a review should edit tags for.
 * Prefer an explicit fileId; otherwise match ticket/review filenames.
 */
export function matchProjectFileForReview(
  files: ProjectFileTagSource[] | null | undefined,
  hints: {
    fileId?: string | null;
    names?: (string | null | undefined)[];
  },
): MatchedProjectFileTags | undefined {
  if (!files?.length) return undefined;
  if (hints.fileId) {
    const hit = files.find((f) => f.fileId === hints.fileId);
    if (hit) return { fileId: hit.fileId, tags: hit.tags ?? [] };
  }
  const needles = (hints.names ?? [])
    .map((n) => (typeof n === "string" ? basename(n) : ""))
    .filter((n) => n.length > 0);
  if (needles.length === 0) return undefined;
  for (const file of files) {
    const fileName = file.name ? basename(file.name) : "";
    if (!fileName) continue;
    if (needles.includes(fileName)) {
      return { fileId: file.fileId, tags: file.tags ?? [] };
    }
  }
  return undefined;
}
